export const isUrlWhitelisted = (url?: string, whitelistedHosts: string[] = []): boolean => {
  if (!url) {
    return false;
  }

  const isRelativeUrl = url.startsWith("/");
  if (isRelativeUrl || whitelistedHosts.length === 0) {
    return true;
  }

  const urlHost = new URL(url).host;
  return whitelistedHosts.includes(urlHost);
};
